import ActivityList from './list';
import ActivityEdit from './edit';
import ActivityShow from './show';

export default {
    list: ActivityList,
    show: ActivityShow,
    edit: ActivityEdit
};
